export default function ReviewReply({ text, dark = false, testid }) {
  if (!text) return null;
  return (
    <div data-testid={testid} className={`mt-3 border-l-2 pl-3 text-xs leading-relaxed ${dark ? "border-honey/50 text-cream/65" : "border-amber-deep/40 text-bark-soft"}`}>
      <p className={`mb-0.5 font-semibold ${dark ? "text-honey" : "text-amber-deep"}`}>Réponse de Pétales de Miel</p>
      <p className={dark ? "line-clamp-3" : ""}>{text}</p>
    </div>
  );
}
